import React, { forwardRef } from "react";
import { Field as FormikField } from "formik";
import PropTypes, { oneOf } from "prop-types";

import ChoiceInput from "./ChoiceInput";
import EmailInput from "./EmailInput";
import LabelledInput from "./LabelledInput";

const Input = forwardRef((props, ref) => (
  <FormikField {...props}>
    {({ field, form }) => {
      switch (props.type) {
        case "checkbox":
        case "radio":
        case "switch":
          return <ChoiceInput ref={ref} field={field} form={form} {...props} />;
        case "email":
          return (
            <EmailInput
              ref={ref}
              error={form.errors?.email}
              field={field}
              {...props}
            />
          );
        default:
          return (
            <LabelledInput ref={ref} field={field} form={form} {...props} />
          );
      }
    }}
  </FormikField>
));

Input.displayName = "Input";

Input.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  type: oneOf([
    "email",
    "text",
    "textarea",
    "checkbox",
    "radio",
    "toggle",
    "select",
    "switch"
  ])
};

Input.defaultProps = {
  children: null,
  className: "",
  inputClassName: "",
  type: "text"
};

export default Input;
